module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n8n5n1r-9a1e19653ec9e0e43c032a6a0c8410f5.svg";